import React, { Fragment, useState, useCallback } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Box } from '@material-ui/core'

import * as CONST from './modalSettings'
import { addOnboardingTime } from './../gql'
import { validate } from './validate'
import Form from '../../../../../Components/Form'
import SubmitButton from '../../../../../Components/Form/SubmitButton'
import { SelectDashboard } from '../../../../../Components/Form/SelectDashboard'
import ConfirmableFormTimePicker from '../../../../../Components/Form/ConfirmableFormTimePicker'
import FormLabel from '../../../../../Components/Form/FormLabel'
import Button from '../../../../../Components/Form/Button'

const OnboardingTimesAddModal = props => {
  const [errors, setErrors] = useState({})
  const { cityId, fetchOnboardingTimes, closeModal, cypress_id } = props
  const initialValues = {
    timeStart: '10:00',
    timeStop: '12:00',
    day: CONST.DAYS_OF_THE_WEEK[0].value,
    type: 'ONLINE',
  }
  const handleAddOnboardingTime = useCallback(async form => {
    const payload = {
      cityId: cityId,
      onboardingTimes: [
        {
          day: Number(form.day.value),
          type: form.type.value,
          timeStart: form.timeStart.value,
          timeStop: form.timeStop.value,
        },
      ],
    }
    await addOnboardingTime(payload)
    fetchOnboardingTimes()
  }, [])

  const handleFormUpdate = useCallback(
    (value, form) => {
      const errors = validate(
        {
          timeStop: form.timeStop && form.timeStop.value,
          timeStart: form.timeStart && form.timeStart.value,
          day: form.day && form.day.value,
        },
        {
          onboardingTimesList: props.onboardingTimesList,
        },
      )
      setErrors(errors)
    },
    [props.onboardingTimesList],
  )

  return (
    <Form onUpdate={handleFormUpdate} onSubmit={handleAddOnboardingTime}>
      <Row>
        <Fragment>
          <Box mr={5}>
            <Col xs={12}>
              <SelectDashboard
                label="Day"
                name="day"
                initValue={initialValues.day}
                options={CONST.DAYS_OF_THE_WEEK}
                cypress_id={`${cypress_id}-day-dropdown`}
              />
            </Col>
          </Box>
          <Box>
            <Col xs={12}>
              <SelectDashboard
                label="Type"
                name="type"
                initValue={initialValues.type}
                options={CONST.TYPE}
                cypress_id={`${cypress_id}-type-dropdown`}
              />
            </Col>
          </Box>
        </Fragment>
      </Row>
      <Row>
        <Col xs={6}>
          <FormLabel label="Start Time" />
          <ConfirmableFormTimePicker
            name="timeStart"
            pickerId="timeStart"
            pickerName="Start Time"
            initValue={initialValues.timeStart}
            dialogTitle="Confirm pick up start time"
            cypress_id={`${cypress_id}-start-time-input`}
          />
          {errors.timeStart && (
            <span style={{ color: 'red' }}>{errors.timeStart}</span>
          )}
        </Col>
        <Col xs={6}>
          <FormLabel label="End Time" />
          <ConfirmableFormTimePicker
            pickerId="timeStop"
            name="timeStop"
            pickerName="End Time"
            initValue={initialValues.timeStop}
            dialogTitle="Confirm pick up start time"
            cypress_id={`${cypress_id}-end-time-input`}
          />
          {errors.timeStop && (
            <span style={{ color: 'red' }}>{errors.timeStop}</span>
          )}
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={6}>
          <Button
            value="Cancel"
            onClick={() => closeModal()}
            cypress_id={`${cypress_id}-cancel-button`}
          />
        </Col>
        <Col xs={6}>
          <SubmitButton
            value="Add"
            disabled={errors.timeStart || errors.timeStop}
            onClick={() => closeModal()}
            cypress_id={`${cypress_id}-submit-button`}
          />
        </Col>
      </Row>
      <br />
      <br />
    </Form>
  )
}

export default OnboardingTimesAddModal
